import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ModalDialog from "../components/common/ModalDialog";
import AuthContext from "../context/auth/AuthContext";
import AlertContext from "../context/alert/AlertContext";
import ConfigContext from "../context/config/ConfigContext";
import CardContext from "../context/card/CardContext";
import CartContext from "../context/cart/CartContext";
import GroupContext from "../context/group/GroupContext";
import SubscribeContext from "../context/subscribe/SubscribeContext";
import EmployeeContext from "../context/employee/EmployeeContext";
import CompCardContext from "../context/comp-card/CompCardContext";

const useIdleTimer = () => {
  const authContext = useContext(AuthContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const subscribeContext = useContext(SubscribeContext);
  const groupContext = useContext(GroupContext);
  const employeeContext = useContext(EmployeeContext);
  const compCardContext = useContext(CompCardContext);
  const configContext = useContext(ConfigContext);
  const alertContext = useContext(AlertContext);

  const { resetCardState } = cardContext;
  const { resetCartState } = cartContext;
  const { resetSubscribeState } = subscribeContext;
  const { resetGroupState } = groupContext;
  const { resetEmployeeState } = employeeContext;
  const { resetCompCardState } = compCardContext;
  const {
    resetConfigState,
    getConfigValue,
    loaded,
    loadConfig,
    getConfigValueByCode,
  } = configContext;
  const { setAlert, clearAlerts, setAlertTarget } = alertContext;
  const { token, logout, extendSession } = authContext;

  const [showDialog, setShowDialog] = useState(false);
  const [userIdleTime, setUserIdleTime] = useState(0);
  var [timer, setTimer] = useState(null);
  const [tokenTimeout, setTokenTimeout] = useState(null);
  var [tokenTimer, setTokenTimer] = useState(null);
  const [tokenIdleTime, setTokenIdleTime] = useState(0);
  const [configValues, setConfigValues] = useState({
    tokenValidity: 0,
    sessionTimeout: 0,
    sessionTimeoutExpiryWarning: 0,
  });
  const [prevToken, setPrevToken] = useState(
    localStorage.getItem("token") ? localStorage.getItem("token") : ""
  );
  const [toContinue, setToContinue] = useState(true);
  const [dontContinueTokenTimer, setDontContinueTokenTimer] = useState(false);
  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  const history = useHistory();
  let { tokenValidity, sessionTimeout, sessionTimeoutExpiryWarning } =
    configValues;

  const getTimerValues = async () => {
    if (loaded) {
      if (
        (tokenValidity === 0,
        sessionTimeout === 0,
        sessionTimeoutExpiryWarning === 0)
      ) {
        let tokenValidity = await getConfigValue(
          "generalConfig",
          "Token_Validity",
          "User_Config"
        );
        let sessionTimeout = await getConfigValue(
          "generalConfig",
          "Session_Timeout",
          "User_Config"
        );
        let sessionTimeoutExpiryWarning = await getConfigValue(
          "generalConfig",
          "Session_Timeout_Expiry_Warning",
          "User_Config"
        );
        console.log(
          "Idle configValues",
          tokenValidity,
          sessionTimeout,
          sessionTimeoutExpiryWarning
        );
        setConfigValues({
          tokenValidity,
          sessionTimeout,
          sessionTimeoutExpiryWarning,
        });
      }
    } else {
      const getConfigDetails = async () => {
        try {
          const res = await loadConfig();
          console.log("CONFIG RULE MAP", res);
        } catch (err) {
          clearAlerts();
          const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
          setAlert(msg, "danger");
        }
      };
      getConfigDetails();
    }
  };
  useEffect(() => {
    getTimerValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  useEffect(() => {
    if (token && timer === null) {
      console.log(
        "Idle configValues in token",
        tokenValidity,
        sessionTimeout,
        sessionTimeoutExpiryWarning
      );
      if (token !== prevToken) {
        createIdleTimer();
        createTokenTimeout(tokenValidity - sessionTimeoutExpiryWarning);
        setPrevToken(token);
        setHasLoggedOut(false);
        setToContinue(true);
        setDontContinueTokenTimer(false);
      } else if (localStorage.getItem("idle")) {
        console.log("IDLE NEW TIMER @ reload", timer);
        let t = setInterval(startIdleTimer, 60000);
        setTimer(t);
      }
    } else {
      clearInterval(timer);
      setTimer(null);
      clearInterval(tokenTimer);
      setTokenTimer(null);
      setTokenIdleTime(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const createIdleTimer = () => {
    if (timer === null) {
      console.log("IDLE NEW TIMER user", timer);
      let t = setInterval(startIdleTimer, 60000);
      setTimer(t);
    }
  };

  function startIdleTimer() {
    setUserIdleTime((prevMin) => {
      return prevMin + 1;
    });
  }

  const createTokenTimeout = (time) => {
    const millisecTime = time * 1000;
    console.log("Idle tokenTimeout millisec", millisecTime);
    if (tokenTimeout === null) {
      console.log("IDLE NEW tokenTimeout", tokenTimeout, millisecTime);
      let t = setTimeout(tokenHasTimeout, millisecTime);
      setTokenTimeout(t);
    }
  };

  const tokenHasTimeout = () => {
    console.log(
      "Idle tokenTimeOut last mins -->",
      sessionTimeoutExpiryWarning / 60,
      tokenTimeout,
      hasLoggedOut
    );
    if (!hasLoggedOut) {
      clearTimeout(tokenTimeout);
      setTokenTimeout(null);
      console.log("IDLE NEW TIMER token", tokenTimer, tokenTimeout);
      let t = setInterval(startTokenTimer, 60000);
      setTokenTimer(t);
    }
  };

  function startTokenTimer() {
    setTokenIdleTime((prevMin) => {
      return prevMin + 1;
    });
  }

  function resetTimer() {
    console.log("Idle timer reset", userIdleTime);
    if (toContinue) {
      setUserIdleTime(0);
      if (tokenTimer) {
        clearInterval(tokenTimer);
        setTokenTimer(null);
        setTokenIdleTime(0);
        onExtendSession();
      }
    }
  }

  window.onload = resetTimer;
  window.onclick = resetTimer;
  window.onkeypress = resetTimer;

  useEffect(() => {
    console.log("IDLE MIN user ", userIdleTime, timer);
    localStorage.setItem("idle", timer);
    if (
      userIdleTime !== 0 &&
      userIdleTime === (sessionTimeout - sessionTimeoutExpiryWarning) / 60
    ) {
      setShowDialog(true);
    }
    if (userIdleTime !== 0 && userIdleTime >= sessionTimeout / 60) {
      clearInterval(timer);
      setTimer(null);
      setUserIdleTime(0);
      onLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIdleTime]);

  useEffect(() => {
    const lastMin = Number(sessionTimeoutExpiryWarning) / 60;
    console.log("IDLE MIN token ", tokenIdleTime, lastMin, tokenTimer);
    if (tokenIdleTime !== 0 && tokenIdleTime >= lastMin) {
      clearInterval(tokenTimer);
      setTokenIdleTime(0);
      onLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenIdleTime]);

  const resetUseIdleTimer = () => {
    console.log("IDLE reset ......");
    setHasLoggedOut(true);
    clearInterval(timer);
    setTimer(null);
    setUserIdleTime(0);
    clearInterval(tokenTimer);
    setTokenTimer(null);
    setTokenIdleTime(0);
    setTokenTimeout(null);
    clearTimeout(tokenTimeout);
    setTokenTimeout(null);
    setHasLoggedOut(false);
    setToContinue(true);
    setDontContinueTokenTimer(false);
    localStorage.removeItem("idle");
  };

  const onLogout = async () => {
    console.log("IDLE Logging out....");
    resetUseIdleTimer();
    clearAlerts();
    resetCardState();
    resetCartState();
    resetSubscribeState();
    resetGroupState();
    resetEmployeeState();
    resetCompCardState();
    resetConfigState();
    setShowDialog(false);
    try {
      const res = await logout(token);
      if (!res) {
        setAlertTarget("Unexpected Error", "danger", "/");
      }
      history.push("/");
    } catch (err) {
      setAlertTarget(
        "Your session is expired! Please login again",
        "danger",
        "/"
      );
      history.push("/");
    }
  };

  const onNoExtendClose = () => {
    console.log("Idle onNoExtendClose");
    if (tokenTimer) {
      setDontContinueTokenTimer(true);
    }
    setToContinue(false);
    setShowDialog(false);
  };

  const onExtendSession = () => {
    if (!dontContinueTokenTimer) {
      onClose();
      clearInterval(timer);
      setTimer(null);
      setUserIdleTime(0);
      clearInterval(tokenTimer);
      setTokenTimer(null);
      setTokenIdleTime(0);
      extendSession(token);
    }
  };

  const onClose = () => {
    setShowDialog(false);
  };

  const IdleModalDialog = () => {
    if (showDialog) {
      return (
        <ModalDialog
          show={showDialog}
          onClose={onNoExtendClose}
          onSubmit={onClose}
          title={"Warning: Session Expiry"}
          message={`Your session will expire in ${
            sessionTimeoutExpiryWarning / 60
          } minutes. Please confirm if you want to continue.`}
          cancelLabel={"No"}
          submitLabel={"Yes"}
          role="modal"
        />
      );
    } else {
      return "";
    }
  };
  return { IdleModalDialog, resetUseIdleTimer };
};

export default useIdleTimer;
